import { render, staticRenderFns } from "./commodityIndex.vue?vue&type=template&id=43867f90&scoped=true&"
import script from "./commodityIndex.vue?vue&type=script&lang=js&"
export * from "./commodityIndex.vue?vue&type=script&lang=js&"
import style0 from "./commodityIndex.vue?vue&type=style&index=0&id=43867f90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43867f90",
  null
  
)

export default component.exports